import { render } from "./opening-hours.vue?vue&type=template&id=36082f78&scoped=true"
import script from "./opening-hours.vue?vue&type=script&lang=js"
export * from "./opening-hours.vue?vue&type=script&lang=js"

import "./opening-hours.vue?vue&type=style&index=0&id=36082f78&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36082f78"]])

export default __exports__